import { gql } from '@apollo/client';
import PRODUCT from 'api/fragments/PRODUCT';
const ASSIGN_PRODUCT_TO_TENANT = gql `
  ${PRODUCT}
  mutation AssignProductToTenant($productId: ID!, $tenantId: ID!, $variantsPrices: [[ID]]!) {
    assignProductToTenant(
      productId: $productId
      tenantId: $tenantId
      variantsPrices: $variantsPrices
    ) {
      product {
        ...ProductFragment
      }
    }
  }
`;
export default ASSIGN_PRODUCT_TO_TENANT;
